import React from "react";
import QRCode from "qrcode";
import { useEffect, useState } from "react";
import clsx from "clsx";

const QRGenerator = ({ product, size = "regular", format = "5/2" }) => {
  const [qrCodeUrl, setQrCodeUrl] = useState(null);

  useEffect(() => {
    const generateQRCode = async () => {
      try {
        let url = await QRCode.toDataURL(JSON.stringify(product?.qr_code));
        setQrCodeUrl(url);
      } catch (error) {
        console.log("Error generating QRCode : ", error);
      }
    };
    generateQRCode();
  }, [product]);

  const formatPrice = (price) => {
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(price);
  };

  return (
    <div
      className={clsx(
        "w-full border rounded-lg",
        format === "3/2"
          ? "aspect-[2/3] flex flex-col p-0 gap-2"
          : "aspect-[5/2] flex flex-row p-0 gap-0"
      )}
    >
      <div
        className={clsx(
          "flex items-center justify-center",
          format === "3/2"
            ? "flex-col w-auto h-[70%] aspect-square"
            : "flex-col aspect-square h-full"
        )}
      >
        <img
          src={qrCodeUrl}
          className="w-auto h-full aspect-square"
          alt="QR Code"
          loading="lazy"
          decoding="async"
        />
        {format === "3/2" && (
          <p
            className={clsx(
              "font-mono font-medium text-center break-all",
              size === "small" ? "text-[10px]" : "text-[10px]"
            )}
          >
            {product?.qr_code}
          </p>
        )}
      </div>
      <div
        className={clsx(
          "flex flex-col justify-center",
          format === "3/2" ? "flex-1 gap-1 px-4" : "flex-1 gap-1 px-0"
        )}
      >
        {format === "5/2" && (
          <p
            className={clsx(
              "font-mono font-medium text-left break-all",
              size === "small" ? "text-[6px]" : "text-[10px]"
            )}
          >
            {product?.qr_code}
          </p>
        )}

        <p
          className={clsx(
            "font-bold leading-tight",
            size === "small" ? "text-sm" : "text-xl"
          )}
        >
          {product?.product_detail?.name}
        </p>
        <div className="flex flex-row items-center gap-2">
          <p
            className={clsx(
              "leading-tight",
              format === "3/2"
                ? "text-sm"
                : size === "small"
                ? "text-xs"
                : "text-xl"
            )}
          >
            {product?.id}
          </p>
          <p
            className={clsx(
              "text-gray-600",
              format === "3/2"
                ? "text-sm"
                : size === "small"
                ? "text-xs"
                : "text-xl"
            )}
          >
            {product?.color?.name} - {product?.size?.name}
          </p>
        </div>
        <p
          className={clsx(
            "text-gray-600",
            format === "3/2"
              ? "text-sm"
              : size === "small"
              ? "text-xs"
              : "text-lg"
          )}
        >
          {formatPrice(product?.product_detail?.price)}
        </p>
      </div>
    </div>
  );
};

export default QRGenerator;
